//React
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

//Ionic
import {
  IonCard,
  IonBadge,
  IonGrid,
  IonRow,
  IonCol,
  IonIcon,
} from "@ionic/react";
import {
  locationSharp,
  bookmarkOutline,
  bookmark,
  ticket,
} from "ionicons/icons";


function showModal(id) {
  window.openid = id;
  document.getElementById("openmodal").click();
}

function InfoCard(props) {
  // diese Zeile löschen, damit die Speaking URLs wieder funktionieren
  //props.slug = props.id;
  const [interestBadge, setInterestBadge] = useState(false);
  const [hasTourenData, setHasTourenData] = useState(false);

  useEffect(() => {
    /* Check if Profile Interests are part of pitch */

    function checkInterests() {

      props.interests.map((item) => {
        if (item === "Genuss") {
          if (["restaurant", "vintner", "brewery"].includes(props.category)) {
            setInterestBadge(true);
            return true;
          }
          if (props.subcategories.length !== 0) {
            if (
              props.subcategories.subcategory.some((category) =>
                ["restaurant", "vintner", "brewery"].includes(category)
              )
            ) {
              setInterestBadge(true);
              return true;
            }
          }
        } else if (item === "Wellness & Gesundheit") {
          if (["thermal_bath"].includes(props.category)) {
            setInterestBadge(true);
            return true;
          }
          if (props.subcategories.length !== 0) {
            if (
              props.subcategories.subcategory.some((category) =>
                ["thermal_bath"].includes(category)
              )
            ) {
              setInterestBadge(true);
              return true;
            }
          }
          if (props.interesttags.length !== 0) {
            if (
              props.interesttags.tag.some((category) =>
                ["kur", "Kur", "wellness", "Wellness"].includes(category)
              )
            ) {
              setInterestBadge(true);
              return true;
            }
          }
        } else if (item === "Kultur & Geschichte") {
          if (["castle", "museum"].includes(props.category)) {
            setInterestBadge(true);
            return true;
          }
          if (props.subcategories.length !== 0) {
            if (
              props.subcategories.subcategory.some((category) =>
                ["castle", "museum"].includes(category)
              )
            ) {
              setInterestBadge(true);
              return true;
            }
          }
          if (props.interesttags.length !== 0) {
            if (
              props.interesttags.tag.some((category) =>
                ["städte", "Städte"].includes(category)
              )
            ) {
              setInterestBadge(true);
              return true;
            }
          }
        } else if (item === "Schwimmen/Baden") {
          if (["water_park", "lake"].includes(props.category)) {
            setInterestBadge(true);
            return true;
          }
          if (props.subcategories.length !== 0) {
            if (
              props.subcategories.subcategory.some((category) =>
                ["water_park", "lake"].includes(category)
              )
            ) {
              setInterestBadge(true);
              return true;
            }
          }
          if (props.interesttags.length !== 0) {
            if (
              props.interesttags.tag.some((category) =>
                ["meer", "Meer"].includes(category)
              )
            ) {
              setInterestBadge(true);
              return true;
            }
          }
        } else if (item === "Sport und Spaß") {
          if (
            [
              "funicular",
              "ski_lift",
              "golf_course",
              "amusement_park",
              "marina",
            ].includes(props.category)
          ) {
            setInterestBadge(true);
            return true;
          }
          if (props.subcategories.length !== 0) {
            if (
              props.subcategories.subcategory.some((category) =>
                [
                  "funicular",
                  "ski_lift",
                  "golf_course",
                  "amusement_park",
                  "marina",
                ].includes(category)
              )
            ) {
              setInterestBadge(true);
              return true;
            }
          }
          if (props.interesttags.length !== 0) {
            if (
              props.interesttags.tag.some((tagcategory) =>
                [
                  "angeln",
                  "klettern",
                  "radfahren",
                  "mountain biking",
                  "wandern",
                  "Angeln",
                  "Klettern",
                  "Radfahren",
                  "Mountain biking",
                  "Wandern",
                ].includes(tagcategory.name)
              )
            ) {
              setInterestBadge(true);
              return true;
            }
          }
        } else if (item === "Naturnah übernachten") {
          if (["farm", "nature_park"].includes(props.category)) {
            setInterestBadge(true);
            return true;
          }
          if (props.subcategories.length !== 0) {
            if (
              props.subcategories.subcategory.some((category) =>
                ["farm", "nature_park"].includes(category)
              )
            ) {
              setInterestBadge(true);
              return true;
            }
          }
          if (props.interesttags.length !== 0) {
            if (
              props.interesttags.tag.some((tagcategory) =>
                [
                  "im grünen",
                  "naturnah",
                  "urlaub am fluss",
                  "Im grünen",
                  "Naturnah",
                  "Urlaub am fluss",
                ].includes(tagcategory.name)
              )
            ) {
              setInterestBadge(true);
              return true;
            }
          }
        }
      });
    }
    checkInterests();
  }, []);

  function decode(str) {
    let txt = document.createElement("div");
    txt.innerHTML = str;
    var realtext = txt.innerText.replaceAll("&nbsp;", "\u00A0");
    return realtext;
  }

  // Voucher
  let foundValidVoucher = false;

  // Date
  var date = new Date();
  var currentDay = String(date.getDate()).padStart(2, "0");
  var currentMonth = String(date.getMonth() + 1).padStart(2, "0");
  var currentYear = date.getFullYear();

  let today = currentYear + "-" + currentMonth + "-" + currentDay;

  // helper function für Vergleichspreis
  function formatNumberString(input) {
    // Convert the input to a string if it's a number
    const str = typeof input === "number" ? String(input) : input;

    // Check if the string contains a period
    if (str.includes(".")) {
      const [integerPart, decimalPart] = str.split(".");

      // Add a "0" at the end if there's only one number after the period
      if (decimalPart.length === 1) {
        return `${integerPart},${decimalPart}0`;
      } else {
        return str.replace(".", ",");
      }
    }

    return str;
  }
  // Slice the string of Stellplatzlänge and Preis on Load
  if (
    typeof props.stellplaetzeLaenge !== "undefined" &&
    props.stellplaetzeLaenge !== null &&
    props.stellplaetzeLaenge.length > 2
  ) {
    if (props.stellplaetzeLaenge.substring(1, 2) === ".") {
      var stellplaetzeLaenge = props.stellplaetzeLaenge.substring(0, 1);
    } else {
      var stellplaetzeLaenge = props.stellplaetzeLaenge.substring(0, 2);
    }
  }
  if (typeof props.vergleichspreis !== "undefined") {
    if (props.vergleichspreis == 0) {
      var vergleichspreis = "Gratis";
    } else {
      vergleichspreis =
        formatNumberString(props.vergleichspreis) + " " + props.preiseWaehrung;
    }
  }

  function highlightMarker(item) {
    var elements = document.querySelector(`[title*="${item}"]`);
    elements.style.backgroundImage =
      "url(/wp-content/uploads/2023/06/MarkerRed.png";
    elements.style.backgroundRepeat = "no-repeat";
  }

  function unhighlightMarker(item) {
    var elements = document.querySelector(`[title*="${item}"]`);
    elements.style.backgroundImage = "none";
  }

  var target = decode(props.name);

  return (
    <div
      data-icon-id={props.id}
      className="container"
      data-fav={props.fav}
      lang="de"
    >
      {props.stellplatztyp === "Stellplatz" ||
      props.stellplatztyp === "Stellplatz mit Entsorgungsstation" ? (
        <IonCard
          key={props.id}
          color="light"
          className="infocard__cardwrapper"
          id={props.id}
          onMouseEnter={() => highlightMarker(props.id)}
          onMouseLeave={() => unhighlightMarker(props.id)}
        >
          {window.location.href.indexOf("typ=Entsorgungsstation") === -1 &&  target.indexOf("Eigenes Ziel: ") === -1 && (
              <>
                <a onClick={() => showModal(props.id)} className="infocard__bookmark">
                  <IonIcon
                      className="bookmark_active"
                      size="lg"
                      icon={bookmark}
                      color="medium"
                  />
                </a>
                <a onClick={() => showModal(props.id)} className="infocard__bookmark">
                  <IonIcon
                      className="bookmark_inactive"
                      size="lg"
                      icon={bookmarkOutline}
                      color="medium"
                  />
                </a>
              </>
          )}
          <Link
            target={`${
              window.location.hash == "#nosearch" ? "_blank" : "_self"
            }`}
            to={`${
              window.location.hash == "#nosearch"
                ? "/stellplatz/"
                : "/map/pitch/"
            }${props.slug}`}
          >
            <div className="container">
              <div className="row">
                {props.url === "" ? (
                  <div 
                    className="col col-4 infocard__background__image"
                    style={{
                      background: `url('/wp-content/uploads/2023/04/Symbolbild1_c_Hardy-Mutschler_Muster.jpg') no-repeat center`,
                    }}
                  ></div>
                ) : (
                  <div
                    className="col col-4 infocard__background__image"
                    style={{
                      background: `url('${props.url}') no-repeat center`,
                    }}
                  ></div>
                )}

                <div size="8" className="col col-8 infocard__content">
                  {props.premium === "1" && (
                    <IonBadge
                      className="infocard__badge premium"
                      color="tertiary"
                    >
                      Premium-Stellplatz
                    </IonBadge>
                  )}
                  {interestBadge && (
                    <IonBadge
                      className="infocard__badge premium"
                      color="tertiary"
                    >
                      Entspricht deinen Interessen
                    </IonBadge>
                  )}
                  <h4 className="h4__bitter infocard__title">
                    {decode(props.name)}
                  </h4>
                </div>
                <div className="col col-12 infocard__content">
                  <div className="infocard__icons">
                    {props.ausstattung !== undefined &&
                      props.ausstattung.map((item) => {
                        if (
                          item.featureIcon === "n" ||
                          item.featureIcon === "q" ||
                          item.featureIcon === "l" ||
                          item.featureIcon === "k" ||
                          item.featureIcon === "h" ||
                          item.featureIcon === "f" ||
                          item.featureIcon === "z" ||
                          item.featureIcon === "u"
                        ) {
                          return (
                            <span
                              className={`font__icon infocard__icon ${item.featureIcon}`}
                            >
                              {item.featureIcon}
                            </span>
                          );
                        }
                      })}
                  </div>
                  <div className="container padding__none">
                    <div className="row padding__none">
                      <div
                        className="col col-6 padding__none infocard__wrapper__distance"
                      >
                        <h5 className="h5_bitter infocard__heading">
                          {props.city}, {props.country}
                          {props.responseType === "default" && (
                            <>
                              <br />
                              <IonIcon icon={locationSharp} color="primary" />
                              {props.distance} km
                            </>
                          )}
                        </h5>
                      </div>
                      <div 
                        className="col col-6 padding__none ion-text-end infocard__wrapper__badges"
                      >
                        {typeof props.stellplaetzeLaenge !== undefined &&
                          props.stellplaetzeLaenge !== null && (
                            <IonBadge
                              color="secondary"
                              className="infocard__badge__margin"
                            >
                              &lt; {props.stellplaetzeLaenge} m
                            </IonBadge>
                          )}{" "}
                        {props.vergleichspreis !== undefined && (
                          <IonBadge
                            color="secondary"
                            className="infocard__badge__margin"
                          >
                            {vergleichspreis}
                          </IonBadge>
                        )}{" "}
                        {props.voucher !== undefined &&
                          props.voucher.forEach((item) => {
                            item.dateranges.daterange.map((items) => {
                              if (today <= items.validUntil) {
                                foundValidVoucher = true;
                              }
                            });
                          })}
                        {foundValidVoucher && (
                          <>
                            <IonBadge
                              color="primary"
                              className="infocard__badge__margin infocard__badge__voucher"
                            >
                              <IonIcon icon={ticket}></IonIcon>
                            </IonBadge>
                          </>
                        )}
                      </div>{" "}
                    </div>
                  </div>
                </div> 
              </div>
            </div>
          </Link>
        </IonCard>
      ) : (
        <IonCard
          key={props.id}
          color="dark"
          className="infocard__cardwrapper"
          id={props.id}
          onMouseEnter={() => highlightMarker(props.id)}
          onMouseLeave={() => unhighlightMarker(props.id)}
        >

          {window.location.href.indexOf("typ=Entsorgungsstation") === -1 &&  target.indexOf("Eigenes Ziel: ") === -1  &&  (
              <>
                <a onClick={() => showModal(props.id)} className="infocard__bookmark">
                  <IonIcon
                      className="bookmark_active"
                      size="lg"
                      icon={bookmark}
                      color="medium"
                  />
                </a>
                <a onClick={() => showModal(props.id)} className="infocard__bookmark">
                  <IonIcon
                      className="bookmark_inactive"
                      size="lg"
                      icon={bookmarkOutline}
                      color="medium"
                  />
                </a>
              </>
          )}

          {target.indexOf("Eigenes Ziel: ") !== -1  &&  (
              <>
                <IonGrid>
                  <IonRow>

                    <IonCol size="12" className="infocard__content">
                      <h4 className="h4__bitter infocard__title">
                        {decode(props.name)}
                      </h4>
                    </IonCol>

                  </IonRow>
                </IonGrid>
              </>
          )}


          {target.indexOf("Eigenes Ziel: ") === -1  &&  (
              <>

          <Link
            target={`${
              window.location.hash == "#nosearch" ? "_blank" : "_self"
            }`}
            to={`${
              window.location.hash == "#nosearch"
                ? "/stellplatz/"
                : "/map/pitch/"
            }${props.slug}`}
          >
            <IonGrid>
              <IonRow>
                {props.url === "" ? (
                  <IonCol
                    className="infocard__background__image"
                    size="4"
                    style={{
                      background: `url('${window.config.wppath}/wp-content/uploads/2023/07/230620_Dolde_Schild_Muster_378x200px.jpg') no-repeat center`,
                    }}
                  ></IonCol>
                ) : (
                  <IonCol
                    className="infocard__background__image"
                    size="4"
                    style={{
                      background: `url('${props.url}') no-repeat center`,
                    }}
                  ></IonCol>
                )}

                <IonCol size="8" className="infocard__content">
                  <h4 className="h4__bitter infocard__title">
                    {decode(props.name)}
                  </h4>
                </IonCol>




                    <IonCol size="12" className="infocard__content">
                  <table className="infocard__table">
                    {typeof props.entsorgungsstation !== "undefined" && typeof props.entsorgungsstation.features !== "undefined" && props.entsorgungsstation.features.length !== 0  &&
                      props.entsorgungsstation.features.feature.map((item) => {
                        if (item.symbol === "l" || item.symbol === "k") {
                          return (
                            <tr>
                              <td
                                className={`font__icon infocard__icon_entsorgung infocard__table__left ${item.symbol}`}
                              >
                                {item.symbol}
                              </td>
                              <td className="infocard__table__right">
                                {" "}
                                {item.anmerkung}
                              </td>
                            </tr>
                          );
                        }
                      })}

                    {typeof props.entsorgungsstation !== "undefined" && props.entsorgungsstation.system.length !== 0 && (
                      <>
                        <span>System: {props.entsorgungsstation.system}</span><p></p>
                      </>
                    )}
                    {typeof props.entsorgungsstation !== "undefined" && props.entsorgungsstation.durchreise.length !== 0 && (
                      <>
                        <span>{props.entsorgungsstation.durchreise}</span>
                        <p></p>
                      </>
                    )}

                    <br />
                  </table>

                  <IonGrid className="padding__none">
                    <IonRow className="padding__none">
                      <IonCol
                        size="12"
                        size-md="12"
                        className="padding__none infocard__wrapper__distance"
                      >
                        <h5 className="h5_bitter infocard__heading">
                          {props.city}, {props.country}
                          {props.responseType === "default" && (
                            <>
                              <IonIcon icon={locationSharp} color="primary" />
                              {props.distance} km
                            </>
                          )}
                        </h5>
                      </IonCol>
                    </IonRow>
                  </IonGrid>
                </IonCol>




              </IonRow>
            </IonGrid>
          </Link>

              </>
          )}

        </IonCard>
      )}
    </div>
  );
}

export default InfoCard;
